module.exports = __webpack_public_path__ + "img/ch23_04_最后一击.d643f7ce.jpg";